export default function (context) {
  console.log('here were are, in the first plugin.')

  const en = Object.keys(context.store.$i18n.messages.en)
    .sort()
    .reduce(function (acc, key) {
      acc[key] = context.store.$i18n.messages.en[key]
      return acc
    }, {})
  console.log(JSON.stringify(en))

  console.log('languages that need translations:')

  for (const languageKey in context.store.$i18n.messages) {
    if (languageKey === 'en') continue

    console.log('====================')
    console.log(`       ${languageKey}      `)
    console.log('====================')

    const currentLanguageUnsorted = context.store.$i18n.messages[languageKey]
    const currentLanguage = Object.keys(currentLanguageUnsorted)
      .sort()
      .reduce(function (acc, key) {
        acc[key] = currentLanguageUnsorted[key]
        return acc
      }, {})

    // iterate all of the english translations to
    // find missing translations in other languages
    for (const englishKey in en) {
      if (!currentLanguage[englishKey]) {
        console.log(`${englishKey}: '${en[englishKey]}'`)
      }
    }

    console.log(JSON.stringify(currentLanguage))
  }
}
